import { Skeleton } from '@mui/material';
import { SkeletonLoaderProps } from '@/components/atoms/Skeleton/types';

/**
 * SkeletonTypographyLoader is a design system component atom for loading skeleton text. Intended to be used as the
 * loading placeholder for a Typography component.
 *
 * @param SkeletonLoaderProps.
 * @params loaderWidth - The width of the skeleton loader. Defaults to 150px.
 */
export const PSkeletonTypographyLoader = ({ isLoading, loaderWidth = 150, children }: SkeletonLoaderProps) => {
  return isLoading ? <Skeleton width={loaderWidth} /> : <>{children}</>;
};
